import styled from "styled-components";
const ForgetPasswordPageDisplay = styled.div`
  .txt {
    padding: 0 20px;
  }
`;
export default ForgetPasswordPageDisplay;
